import { render, staticRenderFns } from "./VincularSecoes.vue?vue&type=template&id=dc44aff4"
import script from "./VincularSecoes.vue?vue&type=script&lang=js"
export * from "./VincularSecoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports